package com.nonopn.skydome.common.app.api

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GeocodeResult(
    @SerialName("formatted_address")
    val formattedAddress: String,
    val location: GeocodeLatLng
)

@Serializable
data class GeocodeLatLng(
    val latitude: Double,
    val longitude: Double,
)
